import { render, staticRenderFns } from "./auth-two-factor.vue?vue&type=template&id=b1499974&"
import script from "./auth-two-factor.vue?vue&type=script&lang=js&"
export * from "./auth-two-factor.vue?vue&type=script&lang=js&"
import style0 from "./auth-two-factor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports